import { RootState } from "src/redux/store";

export const getActiveProductCategory = (state: RootState) =>
    state.activeProductCategory;
